// core version + navigation, pagination modules:
// import Swiper from 'swiper';
// import { Navigation, Pagination } from 'swiper/modules';

// Swiper.use([Navigation, Pagination]);
// import Swiper from 'swiper';

import Swiper from 'swiper/swiper-bundle.min.mjs'

document.addEventListener('DOMContentLoaded', function () {
  const heroswiper = document.querySelectorAll('#myHeroSlider')

  if (heroswiper.length) {
    function videoInSwiper (swiper, video) {
      let waitForDuration = setInterval(function () {
        if (!isNaN(video.duration) && !video.classList.contains('pause')) {
          video.volume = 0
          video.currentTime = 0
          video.play()
          let newAutoplayTime = video.duration * 1000
          swiper.params.autoplay.delay = newAutoplayTime
          clearInterval(waitForDuration)
        }
      }, 50)
    }

    let regularAutoplayTime = 5000
    let AutoplayTimeIsKnown = 0
    let autoplayTime
    if (
      document.querySelectorAll('#myHeroSlider .swiper-slide > video').length
    ) {
      let video = document.querySelector('#myHeroSlider .swiper-slide > video')
      let waitForDuration = setInterval(function () {
        if (!isNaN(video.duration)) {
          autoplayTime = video.duration * 1000
          AutoplayTimeIsKnown = 1
          clearInterval(waitForDuration)
        }
      }, 50)
    } else {
      autoplayTime = regularAutoplayTime
      AutoplayTimeIsKnown = 1
      console.log('video loaded')
    }

    let initHeroSwiper = setInterval(function () {
      if (AutoplayTimeIsKnown == 1) {
        var mySwiper = new Swiper('.mySwiper', {
          // Optional parameters
          direction: 'horizontal',
          loop: true,
          speed: 1200,
          grabCursor: false,
          mousewheel: false,
          autoHeight: false, 
          pauseOnMouseEnter: false,
          slidesPerView: 1,
          pagination: {
            el: '.swiper-pagination',
            type: 'progressbar'
          },
          // Navigation arrows
          navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev'
          }
        })

        mySwiper.on('slideChange', function () {
          var swiper = this
          // console.log('change slide');
          if (
            document
              .querySelector('#myHeroSlider .swiper-slide-next')
              .querySelectorAll('video').length
          ) {
            videoInSwiper(
              swiper,
              document
                .querySelector('#myHeroSlider .swiper-slide-next')
                .querySelector('video')
            )
          } else {
            swiper.params.autoplay.delay = regularAutoplayTime
          }
        })
          // ---- Akzentfarbe für Progressbar + SearchBtn + Navbar-Toggler
        function updateAccentFromSlide () {
          const activeSlide = document.querySelector('#myHeroSlider .swiper-slide-active');
          if (!activeSlide) return;

          // Mapping: Slide-Background -> Farbschlüssel
          const colorKeyByBg = {
            'bg-gruen-extralight':   'gruen',
            'bg-tuerkis-extralight': 'tuerkis',
            'bg-flieder-extralight': 'flieder'
          };

          let colorKey = null;
          for (const [bgClass, key] of Object.entries(colorKeyByBg)) {
            if (activeSlide.classList.contains(bgClass)) {
              colorKey = key;
              break;
            }
          }
          if (!colorKey) return;

          // Ziele
          const progressFill = document.querySelector('.swiper-pagination-progressbar-fill');
          const searchBtn    = document.querySelector('#searchBtn');
          const toggler      = document.querySelector('.navbar-toggler .toggler-icon');

          // Klassen verwalten
          const btnClasses = ['btn-gruen','btn-tuerkis','btn-flieder'];   // für Progressbar
          const isClasses  = ['is-gruen','is-tuerkis','is-flieder'];      // für Buttons/Toggler

          if (progressFill) {
            progressFill.classList.remove(...btnClasses);
            progressFill.classList.add(`btn-${colorKey}`);
          }

          [searchBtn, toggler].forEach(el => {
            if (!el) return;
            el.classList.remove(...isClasses);
            el.classList.add(`is-${colorKey}`);
          });
        }

        // Beim Swiper-Start sofort prüfen
        updateAccentFromSlide();

        // Bei jedem Slide-Wechsel erneut prüfen
        mySwiper.on('slideChangeTransitionEnd', () => {
          updateAccentFromSlide();
          // kleiner Nachlauf, falls Klassen/Fonts lazy sind
          setTimeout(updateAccentFromSlide, 120);
        });

        // function updateButtonColor () {
        //   const activeSlide = document.querySelector(
        //     '#myHeroSlider .swiper-slide-active'
        //   )
        //   const button = document.querySelector(
        //     '.swiper-pagination-progressbar-fill'
        //   )
          
        //   if (!activeSlide || !button) return

        //   // mögliche Farbklassen
        //   const colorClasses = ['btn-gruen', 'btn-tuerkis', 'btn-flieder']
        //   button.classList.remove(...colorClasses)

        //   // Zuordnung: Hintergrundfarbe → Buttonfarbe
        //   const colorMap = {
        //     'bg-gruen-extralight': 'btn-gruen',
        //     'bg-tuerkis-extralight': 'btn-tuerkis',
        //     'bg-flieder-extralight': 'btn-flieder'
        //   }

        //   for (const [bgClass, btnClass] of Object.entries(colorMap)) {
        //     if (activeSlide.classList.contains(bgClass)) {
        //       button.classList.add(btnClass)
        //     }
        //   }
        // }

        // // Beim Swiper-Start sofort prüfen
        // updateButtonColor()

        // // Bei jedem Slide-Wechsel erneut prüfen
        // mySwiper.on('slideChangeTransitionEnd', updateButtonColor)

        if (
          document
            .querySelector('#myHeroSlider .swiper-slide-active')
            .querySelectorAll('video').length
        ) {
          videoInSwiper(
            mySwiper,
            document
              .querySelector('#myHeroSlider .swiper-slide-active')
              .querySelector('video')
          )
        } else {
          mySwiper.params.autoplay.delay = regularAutoplayTime
        }

        clearInterval(initHeroSwiper)
      }
    }, 100)

    // const viewportWidth = window.innerWidth
    // const element = document.querySelector('.carousel-caption')

    // if (element && viewportWidth > 1199) {
    //   const observer = new IntersectionObserver(entries => {
    //     element.classList.toggle('slide-in-left', entries[0].isIntersecting)
    //   })
    //   observer.observe(element)
    // }
  }
})
      

// Swiper mit Play/Pause Button

document.addEventListener('DOMContentLoaded', function () {
  const buttons = document.querySelectorAll('.play-pause-btn')
  const videos = document.querySelectorAll('.swiper-video')

  function addPlayPauseFunctionality (button, video) {
    button.addEventListener('click', function () {
      if (video.paused) {
        video.play()
        button.classList.add('play')
        button.classList.remove('pause')
        video.classList.add('play')
        video.classList.remove('pause')
      } else {
        video.pause()
        button.classList.add('pause')
        button.classList.remove('play')
        video.classList.add('pause')
        video.classList.remove('play')
      }
    })

    video.addEventListener('ended', videoEnded)
    function videoEnded () {
      // console.log('video ended');
      button.classList.add('pause')
      button.classList.remove('play')
      video.classList.add('pause')
      video.classList.remove('play')
    }
  }

  buttons.forEach((button, index) => {
    addPlayPauseFunctionality(button, videos[index])
  })
})

// Hero-Swiper Play-Botton Position

// function updateButtonPosition () {
//   const viewportWidth = window.innerWidth
//   var swiperCaptions = document.querySelectorAll('.img-video-wrapper')
//   var btnPositions = document.querySelectorAll('.swiper-nav-wrapper')

//   if (swiperCaptions && btnPositions) {
//     swiperCaptions.forEach((swiperCaption, index) => {
//       var btnPosition = btnPositions[index]

//       if (btnPosition) {
//         if (viewportWidth < 991) {
//           var captionHeight = swiperCaption.clientHeight
//           captionHeight += 120
//           btnPosition.style.bottom = captionHeight + 'px'
//         } else {
//           btnPosition.style.bottom = 50 + 'px'
//         }
//       }
//     })
//   }
// }

// window.addEventListener('load', updateButtonPosition)

// window.addEventListener('resize', updateButtonPosition)

// Swiper slides same height
// function equalizeSwiperHeights() {
//   const slides = document.querySelectorAll('.mySwiper .swiper-slide');
//   if (!slides.length) return;

//   // Erst alle Höhen zurücksetzen, um bei Resize neu zu messen
//   slides.forEach(slide => slide.style.height = 'auto');

//   // Höchste Slide ermitteln
//   let maxHeight = 0;
//   slides.forEach(slide => {
//     const h = slide.offsetHeight;
//     if (h > maxHeight) maxHeight = h;
//   });

//   // Alle Slides auf gleiche Höhe setzen
//   slides.forEach(slide => {
//     slide.style.height = maxHeight + 'px';
//   });
// }

// // Beim Laden der Seite
// window.addEventListener('load', equalizeSwiperHeights);

// // Beim Ändern der Fenstergröße
// window.addEventListener('resize', equalizeSwiperHeights);

// document.addEventListener("DOMContentLoaded", function () {
//   const swiperNav = document.querySelector(".swiper-nav-height");
//   const swiperEl = document.querySelector(".swiper-nav-changeheight");

//   // Wenn eines der Elemente nicht existiert, breche hier ab
//   if (!swiperNav || !swiperEl) {
//     console.warn("Swiper-Elemente nicht gefunden. Skript wird beendet.");
//     return;
//   }

//   function positionNav() {
//     // Aktive Slide holen
//     const activeSlide = swiperEl.querySelector(".swiper-slide-active");
//     if (!activeSlide) return;

//     // Innerhalb der aktiven Slide nach Bild oder Video suchen
//     const mediaEl = activeSlide.querySelector("img, video");
//     if (!mediaEl) {
//       console.warn("Kein Bild oder Video in der aktiven Slide gefunden.");
//       return;
//     }

//     // Höhe des Mediums bestimmen
//     const mediaHeight = mediaEl.offsetHeight || 0;

//     // Navigation positionieren (120px + Bildhöhe)
//     // swiperNav.style.position = "absolute";
//     swiperNav.style.top = `${mediaHeight + 120}px`;
//     swiperNav.style.right = "0";
//   }

//   // Initial ausführen (mit kleinem Timeout, falls Bilder noch laden)
//   setTimeout(positionNav, 300);

//   // Bei Fenstergrößenänderung neu berechnen
//   window.addEventListener("resize", positionNav);

//   // Wenn Swiper JS vorhanden ist: bei Slide-Wechsel neu berechnen
//   if (typeof Swiper !== "undefined") {
//     const swiperInstanceEl = document.querySelector(".mySwiper");
//     if (swiperInstanceEl && swiperInstanceEl.swiper) {
//       swiperInstanceEl.swiper.on("slideChangeTransitionEnd", positionNav);
//     } else {
//       console.warn("Swiper-Instanz nicht gefunden.");
//     }
//   } else {
//     console.warn("Swiper ist nicht definiert.");
//   }
// });


// document.addEventListener("DOMContentLoaded", function () {
//   const swiperNavChangeHeight = document.querySelector(".swiper-nav-changeheight");
//   const swiper = document.querySelector(".mySwiper");

//   if (!swiperNavChangeHeight || !swiper) return;

//   let resizeTimeout;

//   function updateNavHeight() {
//     // Nur unter 1200px aktiv
//     // if (window.innerWidth >= 1200) {
//       // swiperNavChangeHeight.style.height = "";
//       // return;
//     // }

//     const activeSlide = swiper.querySelector(".swiper-slide-active");
//     if (!activeSlide) return;

//     const targetCol = activeSlide.querySelector(".swiper-nav-height");
    
//     if (!targetCol) return;

//     const colHeight = targetCol.offsetHeight;

//     if (colHeight > 0) {
//       swiperNavChangeHeight.style.height = `${colHeight - 10}px`;
//     }
//   }

//   // ----> Warten bis Medien vollständig geladen sind
//   function initNavHeight() {
//     updateNavHeight();

//     // kleine Sicherheits-Nachläufe
//     setTimeout(updateNavHeight, 300);
//     setTimeout(updateNavHeight, 1000);
//   }

//   // Nach Seitenladen starten
//   window.addEventListener("load", initNavHeight);

//   // ----> Debounced Resize (verhindert mehrfaches Auslösen)
//   window.addEventListener("resize", function () {
//     clearTimeout(resizeTimeout);
//     resizeTimeout = setTimeout(() => {
//       updateNavHeight();
//       // zweiter Lauf, falls Layout lazy reagiert
//       setTimeout(updateNavHeight, 200);
//     }, 150);
//   });

//   // ----> Bei Swiper-Slide-Wechsel neu berechnen
//   if (typeof Swiper !== "undefined") {
//     const swiperInstance = swiper.swiper;
//     if (swiperInstance) {
//       swiperInstance.on("slideChangeTransitionEnd", () => {
//         updateNavHeight();
//         // kleiner Nachlauf
//         setTimeout(updateNavHeight, 150);
//       });
//     }
//   }
// });
document.addEventListener('DOMContentLoaded', function () {
  const navCol = document.querySelector('#myHeroSlider .swiper-nav-changeheight')
  const mediaWrapper = document.querySelector('#myHeroSlider .img-video-wrapper')

  if (!navCol || !mediaWrapper) return

  function updateNavHeight () {
    // nur bis 1200px aktiv
    if (window.innerWidth < 1200) {
      const mediaHeight = mediaWrapper.offsetHeight
      navCol.style.height = mediaHeight + 'px'
    } else {
      // ab XL: wieder der normalen Layout-Logik überlassen
      navCol.style.height = ''
    }
  }

  // ResizeObserver statt window "resize": reagiert erst, wenn der Browser die
  // neue Größe von mediaWrapper tatsächlich fertig berechnet hat (auch bei
  // Bild-Nachladen, Zoom, Container-Änderungen etc.), nicht schon während des
  // Resize-Events selbst. Vorher wurde manchmal mit der alten (Zwischen-)Höhe
  // gerechnet, wodurch die Navigation sichtbar falsch stand, bis man z.B.
  // manuell neu geladen hat.
  if (window.ResizeObserver) {
    const resizeObserver = new ResizeObserver(updateNavHeight)
    resizeObserver.observe(mediaWrapper)
  } else {
    // Fallback für sehr alte Browser ohne ResizeObserver
    window.addEventListener('load', updateNavHeight)
    window.addEventListener('resize', updateNavHeight)
  }
})
